export const experienceData = [
    {
        id: 1,
        company: 'Commvault',
        jobtitle: 'Software Developer',
        startYear: 'January 2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'CodeSpeedy Technology Private Limited',
        jobtitle: 'Python Programming Intern',
        startYear: 'Jan 2022',
        endYear: 'March 2022'
    },
    // {
    //     id: 4,
    //     company: 'Verzeo',
    //     jobtitle: 'Machine Learning Intern',
    //     startYear: 'May 2020',
    //     endYear: 'August 2020'
    // },
]